export const isDefined = <T>(input: T | undefined | null): input is T =>
  typeof input !== 'undefined' && input !== null;
